<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: "App",
    mounted() {
    
      this.$nextTick(() => {
        // 禁用F12
        document.addEventListener('keydown', this.disableF12);
      })
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.disableF12);
    },
    methods:{
      disableF12(event) {
        if (event.key === 'F12') {
          // event.preventDefault();
        }
      }
    }
};
</script>

<style> 
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}
ul,li,p,span{ padding:0;margin:0;list-style:none;text-align: left;}
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: radial-gradient(circle,#FEFAF7,#F9F5F2);
  /* background-image: url();
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%; */
  /* background-color: #112346; */

}

@media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }

  .main-con {
    margin: auto;
  }
  .el-loading-text{
    text-align: center;
  }
  .el-pagination{
    text-align: center;
    margin-top: 25px;
  }
  .index-header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    background: #fff;
  }
  .index-page{
    margin-top: 73px;
  }

  .el-button {
    /* display: flex;
    align-items: center;
    justify-content: center;
    margin: auto; */
  }
</style>



// WEBPACK FOOTER //
// src/App.vue